/** @jsxImportSource @emotion/react */
import { EuiFlexGroup, EuiFlexItem } from "@inscopix/ideas-eui";
import { useDataTableContext } from "pages/gdt/store/DataTableProvider";
import { PanelCreateFirstTable } from "components/ProjectTabs/ProjectTabProject/panels/PanelCreateFirstTable";
import { PanelAccess } from "./panels/PanelAccess";
import { PanelResources } from "./panels/PanelResources";
import { PanelAbout } from "./panels/PanelAbout";
import { PanelDescription } from "./panels/PanelDescription";
import { css } from "@emotion/react";
import { PanelProjectTables } from "./panels/PanelProjectTables";
import { useRouteMapContext } from "providers/RouteMapProvider/RouteMapProvider";
import { useTenantContext } from "providers/TenantProvider/TenantProvider";
import { isEqual } from "lodash";

// use an owl (> * + *) selector to add a border between each child
const sidebarStyles = css`
  > * + * {
    position: relative;
    margin-top: 16px;
    &::before {
      content: "";
      display: block;
      position: absolute;
      top: -8px;
      left: 0;
      right: 0;
      height: 1px;
      background: #d3dae6;
    }
  }
`;

/*
 * Project homepage tab displaying tables, documentation, and project information sidebar
 */
export const ProjectTabProject = () => {
  const project = useDataTableContext((s) => {
    const project = s.project;
    return {
      id: project.id,
      key: project.key,
    };
  }, isEqual);
  const currentTenantKey = useTenantContext((s) => s.currentTenant.key);
  const tables = useDataTableContext((s) => s.tables);
  const routeMap = useRouteMapContext((s) => s.routeMap);

  const goToSettingsTab = () => {
    routeMap.PROJECT_SETTINGS.dynamicPath({
      tenantKey: currentTenantKey,
      projectKey: project.key,
    }).navigateToReplace();
  };

  const goToAccessTab = () => {
    routeMap.PROJECT_ACCESS.dynamicPath({
      tenantKey: currentTenantKey,
      projectKey: project.key,
    }).navigateToReplace();
  };

  return (
    <EuiFlexGroup>
      <EuiFlexItem grow={8}>
        <EuiFlexGroup direction="column" gutterSize="l">
          <EuiFlexItem>
            {tables.length === 0 ? (
              <PanelCreateFirstTable />
            ) : (
              <PanelProjectTables />
            )}
          </EuiFlexItem>
          <EuiFlexItem>
            <PanelDescription />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
      <EuiFlexItem grow={2} css={sidebarStyles}>
        <PanelAbout goToSettingsTab={goToSettingsTab} />
        <PanelResources />
        <PanelAccess projectId={project.id} goToAccessTab={goToAccessTab} />
      </EuiFlexItem>
    </EuiFlexGroup>
  );
};
